window.React = require('react');
window.ReactDOM = require('react-dom');

/**
 * Conditional debug logging utility
 * @param {...any} args - Arguments to log
 * @description Logs messages only when 'logDebug' URL parameter or localStorage flag is set
 */
console.logDebug = (...args) => {
    if (new URLSearchParams(window.location.search).get('logDebug') || localStorage.getItem('logDebug')) console.log(...args);
}

const lsVer = 4;
const storedVersion = parseInt(localStorage.getItem('lsVer'), 10);

if (storedVersion && storedVersion !== lsVer) {
    localStorage.clear();
    localStorage.setItem('lsVer', lsVer.toString());
}

let lastInteractionTime = new Date();
['click', 'keydown', 'touchstart'].forEach(event => document.addEventListener(event, () => lastInteractionTime = new Date()));

window.openkbs = {
    hasActivity: (idleTime = 30) => (new Date() - lastInteractionTime) <= Math.round(idleTime*1000),
    parseChatId: () => window?.location?.pathname?.match?.(/\/chat\/([\w-]+)/)?.[1]
}